// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1ZucK","containerItemsCenter":"Skeleton_containerItemsCenter__1NPCn"};